import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from '../constant/constants';
import { AuthContext } from '../context/AuthProvider';

function PageNotFound() {
  const { isAuthenticated } = useContext(AuthContext);

  return (
    <div className='min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-white to-purple-50 p-6'>
      <div className='max-w-xl w-full text-center'>
        <div className='mx-auto mb-6 w-24 h-24 rounded-2xl bg-gradient-to-r from-blue-500 to-purple-600 shadow-lg flex items-center justify-center'>
          <span className='text-white text-3xl font-bold'>404</span>
        </div>
        <h1 className='text-3xl font-bold text-text mb-2'>Page not found</h1>
        <p className='text-muted mb-6'>
          The page you are looking for doesn’t exist or was moved.
        </p>
        <div className='flex items-center justify-center'>
          <Link
            to={isAuthenticated ? ROUTES.HOME : ROUTES.LOGIN}
            className='inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-gradient-to-r from-blue-500 to-purple-600 text-white shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition duration-200'
          >
            <span className='font-semibold tracking-wide'>
              {isAuthenticated ? 'Go to Dashboard' : 'Go to Login'}
            </span>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              className='h-5 w-5'
              fill='none'
              viewBox='0 0 24 24'
              stroke='currentColor'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth={2}
                d='M13 7l5 5m0 0l-5 5m5-5H6'
              />
            </svg>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default PageNotFound;
